export const getElementStyles = (
    element: HTMLElement,
    pseudoElt: string = null,
): CSSStyleDeclaration => {
    if (!element) {
        return {} as CSSStyleDeclaration;
    }

    return window.getComputedStyle(element, pseudoElt);
};

export const getElementRealHeight = (element: HTMLElement): number => {
    if (!element) {
        return 0;
    }

    const { marginBottom, marginTop } = getElementStyles(element);
    const { offsetHeight } = element;

    return offsetHeight + parseInt(marginBottom) + parseInt(marginTop);
};
